
const RADIAL_DURATION_SECONDS = 48;
const DESKTOP_INITIAL_ROTATION_DEGREES = -6;
const MOBILE_INITIAL_ROTATION_DEGREES = 0;

const radialMarqueeStates = [];
let radialAnimationFrame = 0;
let previousFrameTime = 0;

function hydrateVideo(video) {
    if (!video || video.dataset.videoHydrated === 'true') return;

    const source = (video.dataset.videoSrc || '').trim();
    if (!source) return;

    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = 'metadata';
    video.src = source;
    video.dataset.videoHydrated = 'true';

    try {
        video.load();
    } catch (_) { }
}

function playVideo(video) {
    hydrateVideo(video);
    video.dataset.videoStatus = 'loaded';

    const promise = video.play();
    if (promise && typeof promise.catch === 'function') {
        promise.catch(() => { });
    }
}

function pauseVideo(video) {
    try {
        video.pause();
    } catch (_) { }
}

function initCardVideoObserver(container) {
    const videos = container.querySelectorAll('video[data-video-lazy]');
    if (!videos.length) return null;

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                const video = entry.target;
                if (entry.isIntersecting) {
                    playVideo(video);
                } else {
                    pauseVideo(video);
                }
            });
        },
        {
            threshold: 0.04,
            rootMargin: '80px'
        }
    );

    videos.forEach((video) => observer.observe(video));
    return observer;
}

function renderRadialMarquees(time) {
    const deltaSeconds = previousFrameTime
        ? Math.min((time - previousFrameTime) / 1000, 0.05)
        : 0;

    previousFrameTime = time;

    radialMarqueeStates.forEach((state) => {
        if (state.isInView && !state.reducedMotion) {
            state.rotation -= (180 / RADIAL_DURATION_SECONDS) * deltaSeconds;

            /* 两组相同内容相隔 180°，回绕后视觉连续。 */
            if (state.rotation <= state.initialRotation - 180) {
                state.rotation += 180;
            }
        }

        state.rotator.style.transform = `rotate(${state.rotation}deg)`;
    });

    //转动渲染
    radialAnimationFrame = requestAnimationFrame(renderRadialMarquees);
}

function initRadialMarquee() {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const containers = document.querySelectorAll('[data-radial-marquee]');

    const marqueeObserver = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                const state = entry.target.__radialMarqueeState;
                if (state) state.isInView = entry.isIntersecting;
            });
        },
        { threshold: 0 }
    );

    containers.forEach((container) => {
        if (container.hasAttribute('data-radial-marquee-initialized')) return;

        const rotator = container.querySelector('[data-radial-marquee-rotate]');
        if (!rotator) return;

        const originalItems = Array.from(rotator.children);
        if (!originalItems.length) return;

        /* 复制一组，形成相隔 180° 的两套相同内容。 */
        originalItems.forEach((item) => {
            const clone = item.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            rotator.appendChild(clone);
        });

        const items = Array.from(rotator.children);
        const angleStep = 360 / items.length;

        items.forEach((item, index) => {
            item.style.setProperty('--item-angle', `${angleStep * index}deg`);
        });

        const state = {
            container,
            rotator,
            items,
            initialRotation: window.matchMedia('(max-width: 479px)').matches
                ? MOBILE_INITIAL_ROTATION_DEGREES
                : DESKTOP_INITIAL_ROTATION_DEGREES,
            rotation: window.matchMedia('(max-width: 479px)').matches
                ? MOBILE_INITIAL_ROTATION_DEGREES
                : DESKTOP_INITIAL_ROTATION_DEGREES,
            isInView: false,
            reducedMotion,
            videoObserver: null,
            resizeObserver: null
        };

        const updateRadius = () => {
            const circleSize = rotator.offsetWidth;
            const cardHeight = items[0]?.offsetHeight || 0;

            /* 卡片中心落在圆周上，卡片外边缘与刻度线基本重合。 */
            const radius = Math.max(0, circleSize / 2 - cardHeight * 0.06);
            rotator.style.setProperty('--orbit-radius', `${radius}px`);
        };

        updateRadius();
        requestAnimationFrame(updateRadius);

        if ('ResizeObserver' in window) {
            state.resizeObserver = new ResizeObserver(updateRadius);
            state.resizeObserver.observe(container);
        } else {
            window.addEventListener('resize', updateRadius, { passive: true });
        }

        state.videoObserver = initCardVideoObserver(container);

        container.__radialMarqueeState = state;
        container.setAttribute('data-radial-marquee-initialized', 'true');
        radialMarqueeStates.push(state);
        marqueeObserver.observe(container);
    });

    if (!radialAnimationFrame) {
        radialAnimationFrame = requestAnimationFrame(renderRadialMarquees);
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRadialMarquee, { once: true });
} else {
    initRadialMarquee();
}
